<template>
  <div>
    <div class="tab-content">
      <SectionTitle
        icon="fas fa-clipboard-list-check"
        content="IV. - V. Programa de Servicios"
        container-class="tag-badge-main-info mt-5 mb-4"
      />
      <Error
        is-alert-mode
        :message="
          'Al añadir o eliminar servicios y no reflejarse en el Tab VIII debe oprimir el botón de Sincronizar Servicios.'
        "
      />

      <Error
        v-if="controversyIVV && controversyIVV.existControversy"
        is-alert-mode
        :message="
          '<b>Parte en Controversia: </b>' + controversyIVV.informationMessage
        "
      />

      <div class="main-content">
        <div class="container-table-striped w-100">
          <div class="table-hover">
            <table class="table content-table-striped table-h">
              <thead>
                <tr class="row global-thead-dark thead-property">
                  <th class="col-12 py-3">Área</th>
                </tr>
              </thead>
              <tbody>
                <tr class="row">
                  <td class="col-md-12 p-0">
                    <Accordion id="peiTab4Accordion">
                      <AccordionItem
                        v-for="programservicearea in programServiceAreas"
                        :id="`psa-${programservicearea.id}`"
                        :key="programservicearea.id"
                        :ref="`psa-${programservicearea.id}`"
                        prevent-expand-id="PSA"
                        :title="getTitle(programservicearea)"
                        :is-discipline="false"
                        @clickItem="onExpandItem"
                        :has-pending-changes="
                          programservicearea.hasPendingChanges
                        "
                      >
                        <div slot="content" class="card-body">
                          <ProgramServiceSummary
                            v-if="
                              expandedItemId == `psa-${programservicearea.id}`
                            "
                            :program-service-area-id="programservicearea.id"
                            :validate-compensation="
                              validateCompensatoryService(
                                programservicearea.disciplineTypeId
                              )
                            "
                            :has-error-in-result-summary="
                              hasErrorInResultSummary(programservicearea.id)
                            "
                            :academic-year-id="pei.configAcademicYearId"
                          />
                        </div>
                        <div
                          v-if="
                            validateCompensatoryService(
                              programservicearea.disciplineTypeId
                            ) || hasErrorInResultSummary(programservicearea.id)
                          "
                          slot="header-error"
                        >
                          <Error
                            :message="resources['5018']"
                            variant="no-border"
                          />
                        </div>
                        <div
                          v-if="
                            ValidationTriggered.validation &&
                              (ValidationTriggered.hasErrors(
                                'Tab4',
                                `PSA-${programservicearea.id}`
                              ) ||
                                ValidationTriggered.hasErrors(
                                  'Tab4',
                                  `PSAWA-${programservicearea.id}`
                                ))
                          "
                          slot="header-error"
                        >
                          <Error
                            :message="
                              ValidationTriggered.hasErrors(
                                'Tab4',
                                `PSAWA-${programservicearea.id}`
                              )
                                ? resources['R03200123']
                                : resources['5018']
                            "
                            variant="no-border"
                          />
                        </div>
                        <div
                          slot="action"
                          v-if="
                            canShowSectionEditable ||
                              canEnableSectionBySubsectionAmendant ||
                              hasSubSectionCinAmendantVIII ||
                              !canUseNewLogic ||
                              admendmentIsEmpty
                          "
                        >
                          <span>
                            <div class="dropdown">
                              <button
                                id="dropdownMenuButton"
                                class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                Acciones
                              </button>
                              <div
                                class="dropdown-menu dropdown-menu-right"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <div
                                  v-if="
                                    (!isPSC && showActions) ||
                                      (isEnglishTeacher &&
                                        programAreas.Ingles ==
                                          programservicearea.areaId) ||
                                      (isBlindTeacher &&
                                        programAreas.ServicioCiegos ==
                                          programservicearea.areaId) ||
                                      (isDeafTeacher &&
                                        programAreas.ServicioSordos ==
                                          programservicearea.areaId)
                                  "
                                  :id="`editPSA-${programservicearea.id}`"
                                  class="dropdown-item"
                                  @click="
                                    goToProgramServicesById(
                                      programservicearea.id
                                    )
                                  "
                                >
                                  <em
                                    :id="
                                      `editPSA-icon-${programservicearea.id}`
                                    "
                                    class="fa fa-pencil text-green pr-1"
                                  />
                                  <span
                                    :id="
                                      `editPSA-span-${programservicearea.id}`
                                    "
                                  >
                                    Editar
                                  </span>
                                </div>
                                <div
                                  v-if="
                                    showActions &&
                                      programservicearea.notRemovableFlag == '0'
                                  "
                                  :id="`deletePSA-${programservicearea.id}`"
                                  class="dropdown-item"
                                  @click="
                                    deleteProgramServiceArea(
                                      programservicearea,
                                      programservicearea.disciplineTypeId
                                    )
                                  "
                                >
                                  <em
                                    :id="
                                      `deletePSA-icon-${programservicearea.id}`
                                    "
                                    class="fa fa-times-circle text-red pr-1"
                                  />
                                  <span
                                    :id="
                                      `deletePSA-span-${programservicearea.id}`
                                    "
                                  >
                                    Eliminar
                                  </span>
                                </div>
                                <div
                                  v-if="isCompletedOrSigned"
                                  class="dropdown-item"
                                  @click="
                                    goToProgramServicesById(
                                      programservicearea.id
                                    )
                                  "
                                >
                                  <em class="fa fa-eye text-green pr-1" />
                                  <span>
                                    Ver detalle
                                  </span>
                                </div>
                              </div>
                            </div>
                          </span>
                        </div>
                      </AccordionItem>
                    </Accordion>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- TODO: implementar nuevo accordion remover la tabla anterior-->
      </div>
      <div class="container">
        <div class="row">
          <div
            v-if="
              ((showActions && canEnableSectionByAmendant) ||
                !canUseNewLogic) &&
                isDraft &&
                !isPSC
            "
            class="col-12"
          >
            <button
              class="btn bg-light-white w-75 pt-1 mt-2 button-add"
              @click="goToProgramServices"
            >
              <i class="fas fa-file-plus pr-4 text-green" />
              <span class="text-button-add-document pt-4">
                Presione aquí para añadir áreas que se desarrollarán en el
                programa de servicios
              </span>
            </button>
          </div>
          <div
            v-if="
              programServiceAreas &&
                programServiceAreas.length == 0 &&
                (!isDraft || !canEditTab4)
            "
            class="col-10"
          >
            <CustomSelectedOption
              value="El PEI o PS no cuenta con programa de servicios en sistema."
            />
          </div>
        </div>
      </div>
      <div class="mt-4">
        <Error
          v-if="
            programServiceAreas &&
              programServiceAreas.length == 0 &&
              ValidationTriggered.validation
          "
          :message="resources[5001]"
          variant="no-border"
        />
        <Error
          v-if="
            ValidationTriggered.validation &&
              ValidationTriggered.hasErrors('Tab4', `PSA-Desync`)
          "
          :message="resources['R03200157']"
          variant="no-border"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import { Accordion, AccordionItem } from '@/components/pei/shared/accordion';
import store from '@/store/index';
import peiStatusEnum from '@/utils/constants/pei/peiStatus.js';
import CustomSelectedOption from '@/components/common/CustomSelectedOption';
import ProgramServiceSummary from '@/components/pei/programservice/ProgramServiceSummary';
import alert from '@/mixin/alert.mixin';
import Error from '@/components/common/Error';
import resourcesService from '@/services/resources.js';
import peiSections from '@/utils/constants/pei/peiSections.js';
import { commonValues } from '@/utils/constants/at/common';
import programAreas from '@/utils/constants/pei/peiProgramAreas.js';
import userRoles from '@/utils/constants/userRoles';

const SECTION_ANSWER = 1;
const SUB_SECTION_A = 33;
const SUB_SECTION_C_VIII = 44;
export default {
  name: 'Tab4PEI',
  mixins: [alert],
  data: () => ({
    selectedPeiStatus: store.getters.SelectedPeiStatus,
    selectedPeiId: store.getters.SelectedPei,
    programServiceAreas: [],
    expandedItemId: 0,
    resources: [],
    haveAt: false,
    pei: null,
  }),
  components: {
    SectionTitle,
    Accordion,
    AccordionItem,
    CustomSelectedOption,
    ProgramServiceSummary,
    Error,
  },
  activated() {
    this.$store.commit('setSaveBtnVisibility', false);
  },
  methods: {
    onExpandItem(item) {
      this.expandedItemId = item.id != 0 && !item.expanded ? item.id : 0;
    },
    hasErrorInResultSummary(programServiceAreaId) {
      const resultSummaryValidation =
        this.$store.state.resultSummaryValidation ?? {};
      // programServiceAreaIds: list of program service area Ids with result summary not completed
      const programServiceAreaIds =
        resultSummaryValidation?.programServiceAreaIds ?? [];
      let hasError = false;
      if (programServiceAreaIds != null && programServiceAreaIds.length > 0) {
        // if find the programServiceAreaId in the list, then that program service area has error
        hasError = programServiceAreaIds.some(
          (id) => id === programServiceAreaId
        );
      }

      return hasError;
    },
    validateCompensatoryService(disciplineId) {
      const listTovalidate = store.state.compensatoryServicesValidation;
      if (listTovalidate != null) {
        const existDataToValidate = listTovalidate.some(
          (obj) => obj.diciplineTypeId === disciplineId
        );
        return existDataToValidate;
      }
      return false;
    },
    async getAreasForPei() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet(
            '/api/pei/getassociatedpeiprogramserviceareas?peiId=' +
              this.selectedPeiId
          )
          .then((res) => {
            self.programServiceAreas = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    goToProgramServices() {
      this.$router.push('/pei/addprogramservice');
    },
    goToProgramServicesById(programServiceAreaId) {
      this.$router.push(
        '/pei/addprogramservice?programservicearea=' + programServiceAreaId
      );
    },
    getTitle(psa) {
      return psa.description && psa.areaId == commonValues.PROGRAM_AREAS.OTROS
        ? psa.areaName + ' - ' + psa.description
        : psa.areaName;
    },
    async deleteProgramServiceArea(programservicearea, disciplineTypeId) {
      let self = this;
      self.haveAt = false;
      let confirmationMessage =
        '¿Está seguro que desea eliminar el área de programa de servicios "' +
        programservicearea.areaName +
        '" ?';
      await self
        .$ApiGet(
          '/api/pei/getexistatevaluation/' +
            self.selectedPeiId +
            '/' +
            programservicearea.areaId
        )
        .then((res) => {
          self.haveAt = res.data;
        });
      if (self.haveAt) {
        confirmationMessage = self.resources['191308'];
      }
      let response = await alert.methods.ShowCancelModal(
        'Atención',
        confirmationMessage,
        'Si',
        'No'
      );
      if (response) {
        let promise = new Promise((resolve) => {
          self
            .$ApiDelete(
              '/api/pei/DeleteProgramServiceArea?id=' + programservicearea.id
            )
            .then((res) => {
              let message = '';
              if (res.data == false) {
                message =
                  'El área de programa de servicios "' +
                  programservicearea.areaName +
                  '" no pudo ser eliminada';
                this.ShowToast('', message, 'error');
              } else {
                message =
                  'El área de programa de servicios "' +
                  programservicearea.areaName +
                  '" fue eliminada exitosamente';
                this.ShowToast('', message, 'success');

                let psaIdx = self.programServiceAreas.findIndex(
                  (x) => x.id == programservicearea.id
                );
                if (psaIdx >= 0) {
                  self.programServiceAreas.splice(psaIdx, 1);
                }
              }
              self.$ApiPost(
                `api/pei/resetcompensatoryServicesByDelete/${disciplineTypeId}/${this.pei.studentSieId}`
              );
              resolve(res.data);
            })
            .catch((err) => {
              self.response = err;
              let errorMessage = self.getMessageError(err)
                ? self.getMessageError(err)
                : 'El área de programa de servicios "' +
                  programservicearea.areaName +
                  '" no pudo ser eliminada';
              this.ShowToast('', errorMessage, 'error');
            });
        });
        return promise;
      }
    },
    async getPei() {
      const { data } = await this.$ApiGet(
        '/api/pei/getpei?peiId=' + this.selectedPeiId
      );
      this.pei = data;
    },
    // Returnm message from http error.
    getMessageError(httpError) {
      try {
        return httpError.response.data.message;
      } catch (error) {
        return null;
      }
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '5001',
        '5018',
        'R03200123',
        '191308',
        'R03200157',
      ]);
    },
  },
  async mounted() {
    await this.loadResources();
    await this.getAreasForPei();
    this.getPei();
  },
  computed: {
    isPSC() {
      return store.state.pei.configUnilateralFlag == '2';
    },
    canUseNewLogic() {
      return (
        this.$store.state['$_admendment'].correlationParameter[0]
          .staticValue === 'true'
      );
    },
    admendmentIsEmpty() {
      return this.$store.state['$_admendment'].sections.length == 0;
    },
    canEnableSectionByAmendant() {
      const sectionsToValidate = [
        parseInt(peiSections.I),
        parseInt(peiSections.IVV),
      ];
      return sectionsToValidate.some((sectionId) =>
        this.$store.state['$_admendment'].sections.some(
          (x) => x.sectionId == sectionId
        )
      );
    },
    canEnableSectionBySubsectionAmendant() {
      const subSsectionsToValidate = [SUB_SECTION_A];
      return subSsectionsToValidate.some((subSectionId) =>
        this.$store.state['$_admendment'].sections.some(
          (x) => x.subSectionId == subSectionId
        )
      );
    },
    hasSubSectionCinAmendantVIII() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUB_SECTION_C_VIII
      );
    },
    canShowSectionEditable() {
      return this.canEnableSectionByAmendant; //&& !this.canUseNewLogic;
    },
    controversyIVV() {
      return store.getters.getPeiControversies(peiSections.IVV);
    },
    ValidationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    canEditTab4() {
      return store.getters.HasPermission('pei.editTab4');
    },
    isDraft() {
      return store.getters.SelectedPeiStatus == peiStatusEnum.Borrador;
    },
    isCompletedOrSigned() {
      return (
        store.getters.SelectedPeiStatus == peiStatusEnum.Completado ||
        store.getters.SelectedPeiStatus == peiStatusEnum.Firmado
      );
    },
    showActions() {
      return this.isDraft && this.canEditTab4;
    },
    programAreas() {
      return programAreas;
    },
    isEnglishTeacher() {
      return this.userRole === userRoles.maestroIngles;
    },
    isBlindTeacher() {
      return this.userRole === userRoles.maestroCiego;
    },
    isDeafTeacher() {
      return this.userRole === userRoles.maestroSordo;
    },
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.title-section {
  text-align: left;
  font: Bold 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
}

.button-add-container {
  background: #fff;
  display: inline;
  padding: 10px 20px 10px 20px;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
}

.button-add-container i {
  color: #2db782 !important;
  font-size: 17px;
  margin-right: 10px;
}

.button-add-container span {
  text-align: center;
  font: Medium 16px/29px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}
.title-round {
  font: 900 16px/19px Lato;
  letter-spacing: 0;
  color: #ffffff;
}

.button-add {
  display: block;
  float: none;
  position: relative;
  margin: 0 auto;
}

.tab-content {
  float: left;
  width: 100%;
}
</style>
